'use strict';
/* eslint-disable no-mixed-operators */

function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;

    return v.toString(16);
  });
}

module.exports = uuid;



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/lib/uuid.js
// module id = 340
// module chunks = 0